/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AppointmentIncludeFieldV1 {
    APPOINTMENT_ID = 'APPOINTMENT_ID',
    TITLE = 'TITLE',
    DESCRIPTION = 'DESCRIPTION',
    TYPE = 'TYPE',
    STATUS = 'STATUS',
    AUDIT = 'AUDIT',
    LOCATION = 'LOCATION',
    EVENT_ID = 'EVENT_ID',
    PARTICIPANTS = 'PARTICIPANTS',
    START_TIMESTAMP = 'START_TIMESTAMP',
    END_TIMESTAMP = 'END_TIMESTAMP',
    REQUEST_REF = 'REQUEST_REF',
    CUSTOM_STATUSES = 'CUSTOM_STATUSES',
    METAS = 'METAS',
    REFS = 'REFS',
}